import { render, staticRenderFns } from "./KrausContainerSelect.vue?vue&type=template&id=4aadd173&lang=pug&"
import script from "./KrausContainerSelect.vue?vue&type=script&lang=js&"
export * from "./KrausContainerSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports